import React from 'react'
import { withRouter } from 'react-router'
import { observer } from 'mobx-react'
import {
  APPConfig,
  convertToBoolean,
  REGION_SELECTOR_URL,
} from 'config/appConfig'
import { Button, Modal } from 'react-bootstrap'
import {
  checkHomeMarket,
  enablePhoneVerificationOnLanding,
  isFeatureEnabled,
  getNestedConfigValue,
  getLocalStorage,
  i18nTranslate,
} from 'src/utils'
import { RegionRestrictionBanner } from 'src/views/components/RegionRestrictionBanner'
import {
  customerContainer,
  accountsContainer,
  cartContainer,
  storeContainer,
  globalModalsContainer,
} from 'src/models'
import {
  getConsent,
  isEnableReEnrollNotificationPopup,
  showTempPopup,
  shouldSuppressHeaderAndModals,
} from '../Header/deps'
import Terms from 'src/views/pages/StudioPage/Terms'
import { PhoneVerificationModal } from 'src/views/components/PhoneVerificationModal/PhoneVerificationModal'
import {
  NotificationPopUp,
  ConversionSuccessPopup,
  NotificationErrorPopup,
  ReEnrollNotificationPopup,
  ReEnrollSignOutErrorPopup,
  NonHomeMarketSignOutPopup,
} from '../BAConversionModal'
import NotifyDirectSellerPopup from '../ProductComponents/NotifyDirectSellerPopup/NotifyDirectSellerPopup'
import FssaiExpiryModal from '../FssaiExpiryModal/FssaiExpiryModal'
import DSSearchModal from '../DSSearchModal/DSSearchModal'

@observer
class GlobalModals extends React.Component {
  componentDidMount() {
    globalModalsContainer.checkDsSearchQueryParam()
    globalModalsContainer.initSubscriptions()
    const customerId =
      customerContainer?.profileResponse?.customer?.id ||
      customerContainer?.profileResponse?.id
    if (customerId) {
      globalModalsContainer.checkAndShowRegionRestrictionModal(
        this.props.location?.pathname
      )
      globalModalsContainer.hasCheckedOnProfileLoad = true
    }
  }

  componentWillUnmount() {
    globalModalsContainer.destroySubscriptions()
  }

  async componentDidUpdate(prevProps) {
    const wasGuest = !customerContainer?.isRegisterUser
    if (prevProps && globalModalsContainer.isCheckDcsvCalled && wasGuest) {
      globalModalsContainer.isCheckDcsvCalled = false
    }

    // Region-restriction checks have no dependency on DCSV data; run before the async gap.
    const currentCustomerId =
      customerContainer?.profileResponse?.customer?.id ||
      customerContainer?.profileResponse?.id

    if (prevProps.location?.pathname !== this.props.location?.pathname) {
      if (currentCustomerId) {
        globalModalsContainer.hasCheckedOnProfileLoad = true
        globalModalsContainer.checkAndShowRegionRestrictionModal(
          this.props.location?.pathname
        )
      }
    }

    if (currentCustomerId && !globalModalsContainer.hasCheckedOnProfileLoad) {
      globalModalsContainer.hasCheckedOnProfileLoad = true
      globalModalsContainer.checkAndShowRegionRestrictionModal(
        this.props.location?.pathname
      )
    }

    if (!globalModalsContainer.isCheckDcsvCalled) {
      await globalModalsContainer.checkDcsvAndCommissionStatus()
    }

    this.updatePhoneVerificationState()

    if (customerContainer.isAccountTerminated) {
      globalModalsContainer.isToShowReEnrollPop = true
    }

    globalModalsContainer.phoneVerifyFromSession = getLocalStorage(
      'phoneVerifyFromSession'
    )

    if (prevProps.location?.search !== this.props.location?.search) {
      globalModalsContainer.checkDsSearchQueryParam()
    }
  }

  updatePhoneVerificationState() {
    const legalAgreementsReceived = accountsContainer?.legalAgreementsReceived
    const tempUser = accountsContainer?.tempUser || ''
    const check = getLocalStorage('check')
    const accountType = customerContainer?.profileResponse?.accounts?.type || ''
    const isLegalVerificationRequired =
      storeContainer.isLegalAgreementsVerificationRequired(accountType)
    // Skip while account type and legal-agreement flags are being refetched out of sync
    // (e.g. right after an account type conversion) to avoid a false-positive flash.
    const shouldShowTerms =
      !accountsContainer?.isSyncingAfterConversion &&
      (isLegalVerificationRequired ? !legalAgreementsReceived : tempUser)

    if (customerContainer.reEnroll) {
      globalModalsContainer.isToShowPhoneVerification = true
      return
    }

    if (
      showTempPopup() &&
      shouldShowTerms &&
      check &&
      customerContainer.isBrandAffiliate(accountType)
    ) {
      globalModalsContainer.isToShowPhoneVerification = false
    }
  }

  render() {
    // Suppress all modals on pages where the header itself is hidden:
    // native-app webviews, Klarna checkout, region-select, online-return, Jitsu signup.
    if (shouldSuppressHeaderAndModals(this.props.location)) {
      return null
    }
    // Suppress account-management modals (phone verification etc.) in MySite preview.
    if (new URLSearchParams(this.props.location?.search || '').has('preview')) {
      return null
    }

    const legalAgreementsReceived = accountsContainer?.legalAgreementsReceived
    const tempUser = accountsContainer?.tempUser || ''
    const check = getLocalStorage('check')
    const accountType = customerContainer?.profileResponse?.accounts?.type || ''
    const isLegalVerificationRequired =
      storeContainer.isLegalAgreementsVerificationRequired(accountType)
    // Skip while account type and legal-agreement flags are being refetched out of sync
    // (e.g. right after an account type conversion) to avoid a false-positive flash.
    const shouldShowTerms =
      !accountsContainer?.isSyncingAfterConversion &&
      (isLegalVerificationRequired ? !legalAgreementsReceived : tempUser)

    const enableFourMonthNotification = convertToBoolean(
      APPConfig?.getAppConfig()?.enableFourMonthNotification
    )
    const enableDirectSellerSearch = isFeatureEnabled('directSellerSearch')
    const fssaiNotificationEnabled =
      getNestedConfigValue(
        'fssaiNotificaionConfig',
        'expNotificaionEnabled'
      ) === 'true'

    return (
      <>
        {!customerContainer.isLoading &&
          showTempPopup() &&
          shouldShowTerms &&
          check &&
          customerContainer.isBrandAffiliate(accountType) &&
          !customerContainer.isToHideTempPopupForReEnroll && (
            <div className="terms-popup">
              <Terms
                getConsent={getConsent}
                showPhoneVerificationPopup={
                  globalModalsContainer.showPhoneVerificationPopup
                }
              />
            </div>
          )}
        {!customerContainer.isLoading &&
          showTempPopup() &&
          globalModalsContainer.isToShowPhoneVerification &&
          customerContainer.fromSessionVerifyPhonePopup &&
          !globalModalsContainer.isToShowReEnrollPop &&
          enablePhoneVerificationOnLanding() &&
          globalModalsContainer.phoneVerifyFromSession && (
            <PhoneVerificationModal
              fromSessionCheck={true}
              isFromHeader={true}
              isFromFourMonthCall={globalModalsContainer.isFromFourMonthCall}
              isFromFourMonthNotification={
                globalModalsContainer.isFromFourMonthNotification
              }
              handleOpenNotificationPopup={() =>
                globalModalsContainer.handleOpenNotificationPopup(
                  this.props.history
                )
              }
              verifyPhoneBasedOnReEnroll={
                globalModalsContainer.verifyPhoneBasedOnReEnroll
              }
              invitationType={globalModalsContainer.invitationType}
              handleNeverMindDoItLater={
                globalModalsContainer.handleNeverMindDoItLater
              }
              handleNeverMindSignOut={
                globalModalsContainer.handleNeverMindSignOut
              }
              handleReEnrollCheckCodeVerified={
                globalModalsContainer.handleReEnrollCheckCodeVerified
              }
              showModal={customerContainer.fromSessionVerifyPhonePopup}
            />
          )}
        {customerContainer.isBrandAffiliate(accountType) &&
          enableFourMonthNotification &&
          globalModalsContainer.dcsvStatus && (
            <NotificationPopUp
              termDate={globalModalsContainer.termDate}
              handleCloseNotificationPopup={
                globalModalsContainer.handleCloseNotificationPopup
              }
              handleShowWarningPopupModal={
                globalModalsContainer.handleShowWarningPopupModal
              }
              handleKeepMeBrandAffiliate={
                globalModalsContainer.handleKeepMeBrandAffiliate
              }
            />
          )}
        {enableFourMonthNotification &&
          globalModalsContainer.showWarningPopup && (
            <ConversionSuccessPopup
              handleShowPhoneVerificationModal={() =>
                globalModalsContainer.handleRedirectToDownConvert(
                  this.props.history
                )
              }
              handleConversionSuccessPopup={
                globalModalsContainer.handleCloseWarningPopupModal
              }
            />
          )}
        {enableFourMonthNotification &&
          globalModalsContainer.isToShowNotificationErrorPopup && (
            <NotificationErrorPopup
              errorMessges={globalModalsContainer.getMessage()}
              handleCloseNotificationErrorPopup={
                globalModalsContainer.handleCloseNotificationErrorPopup
              }
            />
          )}
        {!customerContainer.isLoading &&
          customerContainer.isBrandAffiliate(accountType) &&
          customerContainer.isAccountTerminated &&
          showTempPopup() &&
          customerContainer.accountStatus === 'INACTIVE' && (
            <ReEnrollNotificationPopup
              handleSwitchToMember={globalModalsContainer.handleSwitchToMember}
              handleReEnrollAsBrandAffiliate={
                globalModalsContainer.handleReEnrollAsBrandAffiliate
              }
              handleSignOut={globalModalsContainer.handleSignOut}
            />
          )}
        {globalModalsContainer.isToShowReEnrollSignOutErrorPopup &&
          isEnableReEnrollNotificationPopup() && (
            <ReEnrollSignOutErrorPopup
              isToShowReEnrollSignOutErrorPopup={
                globalModalsContainer.isToShowReEnrollSignOutErrorPopup
              }
              handleClose={globalModalsContainer.handleClose}
            />
          )}
        {isEnableReEnrollNotificationPopup() &&
          customerContainer?.reEnroll &&
          !checkHomeMarket(customerContainer?.profileResponse) && (
            <NonHomeMarketSignOutPopup
              show={true}
              handleSignOut={globalModalsContainer.handleSignOut}
            />
          )}
        {cartContainer?.isNotifyDirectSellerPopupOpen && (
          <NotifyDirectSellerPopup
            product={cartContainer?.skuDetailsForNotifyDirectSeller}
            isOpen={cartContainer?.isNotifyDirectSellerPopupOpen}
            onClose={() => {
              cartContainer?.toggleNotifyDirectSellerPopup()
            }}
          />
        )}
        {fssaiNotificationEnabled && <FssaiExpiryModal {...this.props} />}
        {globalModalsContainer.enableDsSearchPopup &&
          enableDirectSellerSearch && (
            <DSSearchModal
              onClose={globalModalsContainer.handleCloseDsSearchPopup}
            />
          )}
        {globalModalsContainer.showRegionRestrictionModal && (
          <Modal
            className="home-country-modal"
            show={true}
            onHide={globalModalsContainer.handleCloseRegionRestrictionModal}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered>
            <Modal.Body>
              <RegionRestrictionBanner
                isInDialog={true}
                regionSelectorUrl={REGION_SELECTOR_URL}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button
                onClick={
                  globalModalsContainer.handleCloseRegionRestrictionModal
                }>
                {i18nTranslate('cancelOrderForm.cancel', 'Cancel', {
                  nameSpace: 'ssr-resource',
                })}
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </>
    )
  }
}

export default withRouter(GlobalModals)
